import { setEnv } from "./constants";
import { getEnvironment } from "./amplitude";
import { CookieService } from "../services/cookie.service";
import NavigationStack from "../../services/NavigationStack";

export const navigateToComponent = (campaign, path, props, totalInOverallBudget = {}, parentCampaign = '', selectedChildCampaigns = []) => {
  const campaignId = encodeURIComponent(campaign?.id);
  let state;
  if (parentCampaign) {
    state = { campaignObj: campaign, parentCampaign: parentCampaign };
  } else {
    state = { campaignObj: campaign };
  }
  if (selectedChildCampaigns.length > 0) {
    state['selectedChildCampaigns'] = selectedChildCampaigns;
  }
  if (Object.keys(totalInOverallBudget).length) {
    state.totalInOverallBudget = totalInOverallBudget;
  }
  NavigationStack.push(window.location.pathname, props.location?.state);
  props.navigate(`/${path}/${campaignId}`, { state });
};

export const setBaseUrl = () => {
  return new Promise(function (resolve, reject) {
    const host = window.location.host;
    switch (host) {
      case 'qamediaops.annalect.com':
      case 'qaomni.annalect.com':
        setEnv('qa');
        resolve();
        break;
      case 'stgmediaops.annalect.com':
      case 'stgomni.annalect.com':
        setEnv('stg');
        resolve();
        break;
      case 'mediaops.annalect.com':
      case 'omni.annalect.com':
        setEnv('prod');
        resolve();
        break;
      default:
        setEnv('dev');
        resolve();
        break;
    }
  });
};

export const saveRouteChange = (path) => {
  window.OFM.isDev = true;
  window.OFM.routeChanged(path);
};

export const getRouteParam = (name) => {
  if (name === 'clientid' && getEnvironment() === 'local' && CookieService.getCookie("clientId")) {
    return CookieService.getCookie("clientId");
  }
  const search = window.location.search;
  const params = new URLSearchParams(search);
  if (name === 'clientid') {
    return params.get(name) || sessionStorage.getItem("clientid");
  } else {
    return params.get(name);
  }
};
